import React, { useEffect, useState, useRef } from "react";
import {
  Modal,
  Row,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Spinner,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "@workspace/common";

const DynamicFormModal = ({
  header = "Title",
  isOpen,
  closeModal,
  form,
  isLoading = false,
  handleFormSubmit,
  confirmButton = null,
  cancelButton,
}) => {
  const [formTemplate, setFormTemplate] = useState(null);
  const formikRef = useRef(null);

  useEffect(() => {
    if (form) {
      setFormTemplate(form);
    }
  }, [form]);

  const handleModal = () => {
    closeModal();
  };

  return (
    <Modal isOpen={isOpen} centered toggle={handleModal}>
      <ModalHeader toggle={handleModal}>
        <span className="fw-semibold fs-5">{header}</span>
      </ModalHeader>
      <ModalBody>
        <Row>
          <div className="p-0">
            <Form
              template={formTemplate}
              userDetails={null}
              country={null}
              editData={null}
              onSubmit={handleFormSubmit}
              onFormFieldsChange={null}
              errorMessage={null}
              view={true}
              ref={formikRef}
            />
          </div>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Row className="w-100">
          <div className="d-flex flex-row gap-2 p-0">
            {cancelButton && (
              <Button
                className="w-50 fw-semibold"
                type="button"
                onClick={handleModal}
                style={{
                  borderRadius: "8px",
                  border: "1px solid #DFE2E6",
                  backgroundColor: "white",
                }}
              >
                Cancel
              </Button>
            )}
            {confirmButton && (
              <Button
                className="w-50 fw-semibold"
                type="button"
                onClick={() => confirmButton?.handleConfirm()}
                style={{
                  backgroundColor: "#10B967",
                  borderRadius: "8px",
                  color: "white",
                }}
                disabled={isLoading}
              >
                {isLoading ? <Spinner size="sm" /> : `${confirmButton?.title}`}
              </Button>
            )}
          </div>
        </Row>
      </ModalFooter>
    </Modal>
  );
};

export default DynamicFormModal;
